export default {
  markerList: {
    padding: 0,
    marginBottom: 16,
    border: "1px solid #ededed"
  },
  toggleContainer: {
    paddingRight: 25
  },
  currentMarker: {
    opacity: 0.5,
    pointerEvents: "none"
  }
};



// WEBPACK FOOTER //
// ./src/components/MarkerPanel/style.js